import Vue from "vue";
import Router from "vue-router";

import { 
    MAIN_NAV_BAR, 
    MAIN_FOOTER, 
    LAYOUT,
    PRODUTOS,
    INSTITUCIONAL,
    BLOG 
} from './constants/view';

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "index",
    components: { default: LAYOUT, header: MAIN_NAV_BAR, footer: MAIN_FOOTER },
    props: {
      header: { colorOnScroll: 400 },
      footer: { backgroundColor: "black" }
    },    
  },
  {
    path: '/produtos',
    name: 'produtos',
    components: { default: PRODUTOS, header: MAIN_NAV_BAR, footer: MAIN_FOOTER },
    props: {
      header: { colorOnScroll: 400 },
      footer: { backgroundColor: "black" }
    }
  },
  {
    path: '/institucional',
    name: 'institucional',
    components: { default: INSTITUCIONAL, header: MAIN_NAV_BAR, footer: MAIN_FOOTER },
    props: {
      header: { colorOnScroll: 400 },
      footer: { backgroundColor: "black" }
    }
  },
  {
    path: '/blog',
    name: 'blog',
    components: { default: BLOG, header: MAIN_NAV_BAR, footer: MAIN_FOOTER },
    props: {
      header: { colorOnScroll: 400 },
      footer: { backgroundColor: "black" }
    }
  }
];

export default new Router({ 
  routes,
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});